// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.

// This Amplify config is used only for local development.
// TODO(i/ERMINE-90): Delete me once ErmineService is internationalized and localized.

import { getCognitoBypassUrlOpener } from "../helpers";
import { AmplifyConfig } from "../configurations";

export const LOCALHOST_AMPLIFY_CONFIG: AmplifyConfig = {
  // The following is not generic. You need to update it with your own resource IDs.
  // Local Test: L24-L31 Use the default values or change to your own cognito info
  aws_cognito_identity_pool_id:
    "us-west-2:6e356679-f322-447c-aa07-48502b6cef2b",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_1WNA0Bxur",
  aws_user_pools_web_client_id: "6vkn8jgm6k401orr7qmepd7ug2",
  oauth: {
    domain:
      "66d5e6d6-c7e5-4fc4-8c9b-ff00f14dc255.auth.us-west-2.amazoncognito.com",
    redirectSignIn: "https://localhost.workspaces-web.com/",
    redirectSignOut: "https://localhost.workspaces-web.com/",
    scope: [
      "openid",
      "profile",
      "phone",
      "email",
      "aws.cognito.signin.user.admin",
    ],
    responseType: "code",
    urlOpener: getCognitoBypassUrlOpener("AmazonSSO"),
  },
};

export const LOCALHOST_AMPLIFY_CONFIG_FIPS: AmplifyConfig = {
  // The following is not generic. You need to update it with your own resource IDs.
  // Local Test: L24-L31 Use the default values or change to your own cognito info
  aws_cognito_identity_pool_id:
    "us-west-2:6e356679-f322-447c-aa07-48502b6cef2b",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_1WNA0Bxur",
  aws_user_pools_web_client_id: "6vkn8jgm6k401orr7qmepd7ug2",
  oauth: {
    domain:
      "66d5e6d6-c7e5-4fc4-8c9b-ff00f14dc255.auth-fips.us-west-2.amazoncognito.com",
    redirectSignIn: "https://localhost.workspaces-web-fips.com/",
    redirectSignOut: "https://localhost.workspaces-web-fips.com/",
    scope: [
      "openid",
      "profile",
      "phone",
      "email",
      "aws.cognito.signin.user.admin",
    ],
    responseType: "code",
    urlOpener: getCognitoBypassUrlOpener("AmazonSSO"),
  },
  aws_cognito_endpoint: `https://cognito-idp-fips.us-west-2.amazonaws.com/`,
};
